import template from './users-list-view.html';
import { Column } from '../table/model/table-column';

class UsersListViewController {
  constructor(gettext, $filter) {
    'ngInject';
    this.$filter = $filter;

    this.columnsDef = [
      new Column({
        title: gettext('Name'),
        field: 'name',
        sortable: true,
      }),
      new Column({
        title: gettext('Email'),
        field: 'email',
        sortable: true,
      }),
    ];

    this.onSortChange = this.onSortChange.bind(this);

    this.currentPage = 1;
    this.itemsPerPage = 5;
    this.pagedList = [];

    this.setPage = (pageNum = null) => {
      if (pageNum !== null) this.currentPage = pageNum;

      const begin = (this.currentPage - 1) * this.itemsPerPage;
      const end = begin + this.itemsPerPage;
      this.pagedList = (this.filteredList || []).slice(begin, end);
    };
  }

  $onInit() {
    this.itemsPerPage = this.itemsPerPage || 5;
  }

  $onChanges() {
    if (this.users) {
      this.search();
    }
  }

  onSortChange(column) {
    if (typeof column.ascending !== 'boolean') {
      this.columnsDef.forEach((col) => {
        if (col.field !== column.field && typeof col.ascending === 'boolean')
          col.ascending = undefined;
      });
    }

    column.ascending = !column.ascending;

    this.sortList(column);
    this.setPage();
  }

  sortList(column) {
    if (typeof column === 'undefined') {
      column = this.columnsDef.find((column) => typeof column.ascending === 'boolean');
    }

    this.filteredList = this.filteredList.sort(column.sort);
  }

  search() {
    this.filteredList = this.$filter('filter')(this.users || [], this.query);
    this.setPage(1);
  }
}

export default {
  template,
  controller: UsersListViewController,
  controllerAs: 'uVm',
  bindings: {
    users: '<',
   // searchString: '<',
    itemsPerPage: '<',
    onManageClicked: '&?',
  },
};
